module.exports = "/_next/static/images/app-c-icon-70c792148dedb54b16ccc5ddeaf340f5.svg";